import type { QueryClient } from "@tanstack/react-query";
import {
  createRootRouteWithContext,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { useEffect } from "react";
import { trackPageview } from "../lib/analytics";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootRoute,
});

function RootRoute() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);
  return <Outlet />;
}
